// extracted by mini-css-extract-plugin
export default {"root":"styles_root__brsgN","tab-container":"styles_tab-container__S9ZOw","buttons-container":"styles_buttons-container__IfVvI"};